// removed by extract-text-webpack-plugin
module.exports = {"tournaments__scrollable":"tournaments__scrollable-d79ba4","tournaments__content":"tournaments__content-0ffbfd","tournaments__item":"tournaments__item-7c5ea6","tournaments__item_odd":"tournaments__item_odd-5027a6","tournaments__label":"tournaments__label-38edce","tournaments__checkbox":"tournaments__checkbox-7afa5a","tournaments__amount":"tournaments__amount-fac484","tournaments__delete":"tournaments__delete-46a1aa"};


//////////////////
// WEBPACK FOOTER
// ./src/blocks/tournaments/style.pcss
// module id = ./src/blocks/tournaments/style.pcss
// module chunks = 0